import React from 'react'
import NoDataPlaceholder from '../common/NoDataPlaceholder'

interface Props {
    text: string;
}

const CommonEmptyState = ({text}: Props) => {
  return (
    <div style={{background: '#fff'}}>
    <NoDataPlaceholder
    text={
      <div className='ces-text1'>
       {text}
        <div className='ces-text2'>Let's <button
        className='ces-text2-btn'
        onClick={()=>window.open(
          `${window.location.origin}/edge/jobposting/new-job-posting`,
          "_blank"
          )}
        >start writing</button> a new job.</div>
      </div>
    }
    />
  </div>
  )
}

export default CommonEmptyState